 

// $('.afsz-fullimagesM').slick({
//   lazyLoad: 'ondemand',
// 	slidesToShow: 1,
// 	slidesToScroll: 1,
// 	arrows: true,
// 	fade: true
//   // ,dots:true
// }); 
let slidesToScroll_pc = 5;
let page_url_afsz = window.location.href;
if(page_url_afsz.indexOf("openmeetuc-pressure-relief-cushions") >= 0){
  slidesToScroll_pc = 2;
}
if(page_url_afsz.indexOf("openfit2plus") >= 0){
  slidesToScroll_pc = 6;
}
$('.afsz-fullimages').slick({
  lazyLoad: 'ondemand',
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true, 
  focusOnSelect: true,
  arrows: true,
  // dots:true,
  prevArrow: '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
	asNavFor: '.afsz-thumbs'
});
$('.afsz-fullimages').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  if(nextSlide == 0){
    $(".is-template-product .product-openrun-pro2 .afsz-prod-wrapper").removeClass("hide_review_img");
  }else{
    $(".is-template-product .product-openrun-pro2 .afsz-prod-wrapper").addClass("hide_review_img");
  }
});
$(".afsz-thumbs").slick({ 
  lazyLoad: 'ondemand',
	vertical: false,
	infinite: false, 
	asNavFor: ".afsz-fullimages",
	slidesToShow: slidesToScroll_pc,
	slidesToScroll: 1,
	//verticalSwiping: true,
	focusOnSelect: true,
	//centerMode: true,
	rows: 1
}); 
 

$('.selectedVariantid').val($('#sVariantid').text());

$(".o-swatch").click(function(){     
  var inp = $(this).find("input");
  var selColor =  $(inp).val();
  addSelectedColorImg(selColor);
  // if($('body').hasClass('is-template-product')){
  //   document.body.scrollTop = 0;document.documentElement.scrollTop = 0;
  // }
  $('.selectedVariantid').val($('#sVariantid').text());
});

$(".options-color-wrapper").click(function(){
  var selColor =  $(this).attr("data-title");
  addSelectedColorImg(selColor);
});


var now_product_handle = $(".c-variant-selector__swatches-wrapper").attr("product-handle");

if(now_product_handle == "opencomm2uc" || now_product_handle == "openmeet" || now_product_handle == "opencomm2uc2025upgrade"){//处理openrun加磁浮类型2uc产品无法展示橱窗图
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  sCol = sCol.replace(" ","-\/-");
  addSelectedColorImg(sCol);
}else{
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  addSelectedColorImg(sCol);
}

  

if($(".connectivity.o-toggle .o-toggle__switch.is-active").length > 0){
  addSelectedColorImg("USB-A");
}

function addSelectedColorImg(col){    
  let newCol=col;
 if(col.includes('+')) {
  newCol=col.split("+")[0];
 }
 if(col.includes('/')) {
	newCol=col.replace("/","\\/");
   }

 
 
  if($('.afsz-prod-wrapper').hasClass('fl')){
	var selectedColor = "." + newCol;
  	selectedColor = selectedColor.trim().replaceAll(' ','-');
// console.log(selectedColor,"selectedColor");
	$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickFilter',selectedColor);      
     $('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickGoTo', 0);
  
	$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickFilter',selectedColor);	   
    $('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickGoTo', 0);
    setTimeout(function(){
      $('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickGoTo', 0);
      $('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickGoTo', 0);
      $(".afsz-thumbs .afsz-thumbs__thumb").click(function(){
        let now_index = parseInt($(this).attr("data-slick-index")) % slidesToScroll_pc;
        setTimeout(function(){
          // console.log(now_index);
          $('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickGoTo', now_index);   
        },500);
      });
    },100);
  
	// $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickUnfilter');
 //  	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickFilter',selectedColor);
 //    $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickGoTo', 0);
}}
